import { toDisplayString } from '@/lib/utils';

/**
 * Extract a cell value from a row using either a key accessor or a function accessor.
 */
export function getCellValue<T>(row: T, accessor: keyof T | ((row: T) => unknown)): unknown {
  if (typeof accessor === 'function') {
    return accessor(row);
  }
  return row[accessor];
}

/**
 * Compare two unknown values for sorting, with support for strings, numbers,
 * and a fallback that uses toDisplayString to avoid implicit object coercion.
 */
export function compareValues(a: unknown, b: unknown, direction: 'asc' | 'desc'): number {
  const aVal = a ?? '';
  const bVal = b ?? '';

  if (typeof aVal === 'string' && typeof bVal === 'string') {
    const comparison = aVal.localeCompare(bVal, undefined, { sensitivity: 'base' });
    return direction === 'asc' ? comparison : -comparison;
  }

  if (typeof aVal === 'number' && typeof bVal === 'number') {
    return direction === 'asc' ? aVal - bVal : bVal - aVal;
  }

  const aStr = toDisplayString(aVal);
  const bStr = toDisplayString(bVal);
  const comparison = aStr.localeCompare(bStr, undefined, { sensitivity: 'base' });
  return direction === 'asc' ? comparison : -comparison;
}
